// ────────────────────────────────────────────────────────────
// DEAL DESK — bottom-of-funnel shell (/deal-desk)
// ────────────────────────────────────────────────────────────
// One titled deal at a time, worked deeply. Deals appear here when
// the title agent has written their chain; there is no manual
// creation or import. Currently in fixture mode against the
// Robert J. White reference deal while we iterate the layout.

import { Link, Navigate, Route, Routes } from 'react-router-dom';
import { DealPage } from './DealPage';
import { DealsList } from './DealsList';
import { TractPage } from './TractPage';
import { TractsList } from './TractsList';
import { WeldSessionChip } from '../mi/components/WeldSessionChip';
import './dealdesk.css';

export function DealDeskApp() {
  return (
    <div className="dd-root">
      <header className="dd-topbar">
        <img src="/brand/timberline-logo.svg" alt="Timberline" className="brand-logo" />
        <span className="dd-brand-divider">/</span>
        <span className="dd-brand-app">Deal Desk</span>
        <Link to="/deal-desk" className="dd-top-link" style={{ marginLeft: 14 }}>Deals</Link>
        <Link to="/deal-desk/tracts" className="dd-top-link">Tracts</Link>
        <div className="dd-topbar-right">
          <WeldSessionChip />
          <Link to="/select" className="dd-top-link">↔ Switch workspace</Link>
          <a href="https://app.close.com" target="_blank" rel="noreferrer" className="dd-top-link">Close ↗</a>
          <a href="https://recording.weld.gov/web/" target="_blank" rel="noreferrer" className="dd-top-link">Weld Clerk ↗</a>
        </div>
      </header>

      <Routes>
        <Route index element={<DealsList />} />
        <Route path="tracts" element={<TractsList />} />
        <Route path="tracts/:trs" element={<TractPage />} />
        <Route path="deals/:dealId" element={<DealPage />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </div>
  );
}
